<template>
    <span class="step-info">
        <span class="step-info-i"></span>
        <div class="step-info-msg bottom-right-msg">
            {{ $t('In rare cases, due to time zones, manual processing, or high demand, delivery may take up to 24 hours.', { ns:'product' }) }}
        </div>
    </span>
</template>

<script>
</script>

<style scoped lang="scss">
.step-info {
    margin-left: 0;
    position: relative;
    .step-info-i {
        margin-left: 0;
        display: block;
        //background-image: url('/webpack-assets/img/product/icons/info-small.svg');
    }
    .step-info-msg {
        right: -7px;
        white-space: normal;
    }
}
</style>